import type { CopilotAgent } from "@yazamco/shared-types";
import { Icon } from "../../components/ui/Icon";

interface Props {
  value: string | null;
  models: CopilotAgent[];
  onChange: (id: string | null) => void;
  onClose: () => void;
  onManage: () => void;
}

/**
 * "Agent", drawn as the canvas draws it: a radio list where an agent
 * that pins its own knowledge source carries a padlock, and one footer link
 * out to where the models are maintained.
 *
 * The content only; the trigger and the placement belong to the composer.
 */
export function AgentPanel({
  value,
  models,
  onChange,
  onClose,
  onManage,
}: Props): JSX.Element {
  function pick(id: string | null): void {
    onChange(id);
    onClose();
  }

  return (
    <>
      <div className="cp-pop-head">
        <strong>Agent</strong>
      </div>
      <div className="cp-pop-scroll">
        <label className="cp-pop-row" onClick={() => pick(null)}>
          <input
            type="radio"
            name="cp-agent"
            checked={value === null}
            onChange={() => pick(null)}
          />
          <span>No model</span>
        </label>
        {models.map((model) => (
          <label
            key={model.id}
            className="cp-pop-row"
            title={model.description ?? undefined}
            onClick={() => pick(model.id)}
          >
            <input
              type="radio"
              name="cp-agent"
              checked={value === model.id}
              onChange={() => pick(model.id)}
            />
            <span>{model.name}</span>
            {model.knowledgeScope && (
              <Icon name="lock" size={13} label="Knowledge source locked" className="cp-pop-chevron" />
            )}
          </label>
        ))}
        {models.length === 0 && (
          <p className="cp-pop-hint">No agents yet.</p>
        )}
      </div>
      <div className="cp-pop-foot">
        <button
          type="button"
          className="cp-pop-link"
          onClick={() => {
            onClose();
            onManage();
          }}
        >
          Manage agents
        </button>
      </div>
    </>
  );
}
